
import * as FileSaver from "file-saver";
import { Component, OnInit, ViewChild } from '@angular/core';
import { Log } from 'ng2-logger';
import { ToolRequestsService } from '@app/core/services/tool-requests.service';
import { HttpResponse } from "@angular/common/http";
import { RequestHistoryService } from "@services/request-history.service";
import { TableConfig } from "@app/shared/util/table-config.utils";
import { ToolReturnHistory } from "@models/tool-return-history.model";
import * as _ from "lodash";
import { ToastsManager } from "@app/shared/util/toastr.service";
import { TranslateService } from '@ngx-translate/core';
import { ToolReturn } from "@app/shared/models/tool-return.model";
import { ToolReturnsService } from "@app/core/services/tool-returns.service";
import {PendingToolReturnsModalComponent} from "@app/shared/pages/pending-tool-returns-modal/pending-tool-returns-modal.component";


@Component({
    selector: 'app-tool-return-history',
    templateUrl: './tool-return-history.component.html',
    styleUrls: ['./tool-return-history.component.scss']
})
export class ToolReturnHistoryComponent implements OnInit {

    _logger = Log.create(ToolReturnHistoryComponent.name);

    @ViewChild(PendingToolReturnsModalComponent, {static: true}) modal: PendingToolReturnsModalComponent;

    toolReturnHistory: ToolReturnHistory[] = [];
    tableConfig = new TableConfig();

    requestConfig = new TableConfig();

    tableFilters = [];
    reportFilters = [];

    isLoadingReturnsHistory = false;
    isLoadingDownload: boolean;
    selectedToolReturn = new ToolReturn();

    public toolName: string;
    public toolUid: string;
    onNameChanged = _.debounce(this.nameChanged, 300);
    onUidChanged = _.debounce(this.uidChanged, 300);

    constructor(private requestHistoryService: RequestHistoryService,
        private toolRequestsService: ToolRequestsService,
        private toolReturnsService: ToolReturnsService,
        private toastr: ToastsManager,
        private translationService: TranslateService) { }

    ngOnInit() {
        this.tableConfig.sorter = {
            field: 'date',
            IsSortingAscending: false
        };
        this.getReturnsHistory(this.tableConfig);
    }

    onFilterChange(tableFilters: any = [], reportFilters: any = []) {
        this.tableFilters = tableFilters;
        this.reportFilters = reportFilters;

        this.tableConfig.filters = this.reportFilters.concat(this.tableFilters);

        this.getReturnsHistory(this.tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.getReturnsHistory(tableConfig);
    }

    getReturnsHistory(tableConfig = this.tableConfig) {
        this.tableConfig = tableConfig;
        this.isLoadingReturnsHistory = true;
        this.requestHistoryService.getReturnHistory(tableConfig).subscribe(data => {
            this.toolReturnHistory = data.toolReturnHistory;
            this.tableConfig.pager.count = data.count;
            this.isLoadingReturnsHistory = false;
        },
            (error: any) => {
                this.isLoadingReturnsHistory = false;
            });
    }

    onReturnsHistoryDownload(tableConfig = this.tableConfig) {
        this.isLoadingDownload = true;
        this.requestHistoryService.downloadReturnHistoryReport(tableConfig).subscribe(
            (data: HttpResponse<any>) => {
                if (data.body != null) {
                    const blob = new Blob([data.body], { type: 'application/xsls' });
                    const filename = data.headers.get('x-filename');
                    FileSaver.saveAs(blob, filename);
                }
                this.isLoadingDownload = false;
            },
            (error: any) => {
                this.isLoadingDownload = false;
                this.toastr.error(this.translationService.instant('Server_Error'));
            });
    }

    onPageChange(tableConfig: TableConfig) {
        this.tableFilters = tableConfig.filters;
        tableConfig.filters = _.union(this.reportFilters, this.tableFilters);
        this.getReturnsHistory(tableConfig);
    }

    onTableRowClick(request: ToolReturnHistory) {
        this.getToolReturntHistory(request);
    }

    uidChanged() {
        this.tableConfig.filters = this.reportFilters;
        const name = 'toolUid';
        this.tableConfig.removeFilter(name);
        this.tableConfig.upsertFilter(name, this.toolUid);
        this.getReturnsHistory();
    }

    nameChanged() {
        this.tableConfig.filters = this.reportFilters;
        const name = "toolName";
        this.tableConfig.removeFilter(name);
        this.tableConfig.upsertFilter(name, this.toolName);
        this.getReturnsHistory();
    }

    private getToolReturntHistory(request: ToolReturnHistory) {
        this.isLoadingReturnsHistory = true;
        this.toolReturnsService.getToolReturnByToolRequestId(request.toolRequestId).subscribe(
            (details: ToolReturn) => {
                this._logger.info('getToolReturnDetails:: API Returned data', details);
                this.selectedToolReturn = details;
                this.modal.open(this.selectedToolReturn);
                this.isLoadingReturnsHistory = false;
            },
            (error) => {
                this._logger.info('getToolReturnDetails:: API Returned error', error);
            }
        )
    }
}
